export function Logo({ size = 28, showText = true, className = "" }) {
  return (
    <div className={`flex items-center gap-2 ${className}`} data-testid="omy-logo">
      <div
        className="relative flex items-center justify-center rounded-xl"
        style={{
          width: size, height: size,
          background: "linear-gradient(135deg, #E05A36, #F59E0B)",
          boxShadow: "0 6px 18px -6px rgba(224,90,54,0.7)",
        }}
      >
        <span className="absolute rounded-full bg-black/85" style={{ width: size * 0.32, height: size * 0.32 }} />
      </div>
      {showText && (
        <span className="font-display font-bold tracking-tight" style={{ fontSize: size * 0.72 }}>
          OMY
        </span>
      )}
    </div>
  );
}
